import React from 'react';
import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CenterGridItem, SidebarBox, SideGridItem, StyledGridContainer } from './styles';
import { get } from 'global/lib/lodash';

const SidebarXS = 3;

export const GridContainer = (props) => {
  const { fullWidth, ...rest } = props;
  return (
    <StyledGridContainer spacing={0} container fullWidth={fullWidth} {...rest}>
      {props.children}
    </StyledGridContainer>
  );
};

export const LeftSideBar = (props) => {
  const { hidden, children } = props;
  const { boxProps, ...rest } = props;

  return hidden ? null : (
    <SideGridItem
      {...rest}
      padTop
      container
      sx={{ alignItems: 'center', flexDirection: 'column' }}
      size={{ xs: SidebarXS }}
    >
      <SidebarBox {...get(props, 'boxProps', {})} sx={{ displayPrint: 'none' }}>
        {children}
      </SidebarBox>
    </SideGridItem>
  );
};

export const CenterContent = (props) => {
  const { children, fullWidth, selfCenter, ignoreRight, ...rest } = props;

  const overflowHidden = get(props, 'overflowHidden', false);

  const size = fullWidth
    ? { xs: 12 }
    : ignoreRight
    ? { xs: 12, sm: 12, md: 12, lg: 12 - SidebarXS, xl: 12 - SidebarXS }
    : { xs: 12, sm: 12, md: 12, lg: 12 - SidebarXS, xl: 12 - SidebarXS * 2 };

  return (
    <CenterGridItem selfCenter={selfCenter} overflowHidden={overflowHidden} fullWidth={fullWidth} size={size} {...rest}>
      {children}
    </CenterGridItem>
  );
};

export const ScreenCenterContent = styled(CenterContent, {
  shouldForwardProp: (prop) => !['compactTop', 'plain'].includes(prop),
})(({ theme, compactTop, plain }) => ({
  ...(compactTop && {
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(2),
    },
  }),
  ...(!plain && {
    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
  }),
}));

export const RightSideBar = (props) => {
  const { children, hidden } = props;

  return hidden ? null : (
    <SideGridItem sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'none', xl: 'block' } }} size={{ xl: SidebarXS }}>
      {children}
    </SideGridItem>
  );
};

export const PhotosGrid = (props) => {
  return (
    <Grid container>
      <Grid size={{ xs: 0, lg: 1 }} />
      <Grid
        size={{ xs: 12, lg: 10 }}
        // PFM-2630: on mobile the spacer column is 0 (full width), so opt-in
        // `gutter` adds a consistent horizontal margin to the surrounding Photos
        // content container — the single source of the side margin that the
        // inner rows (button row, search, folders/filters) all align to. Not
        // applied on lg (the spacer column provides the desktop inset) and not
        // used by the selected-action bar usage of PhotosGrid.
        sx={props.gutter ? { px: { xs: 2, lg: 0 } } : undefined}
      >
        {props.children}
      </Grid>
    </Grid>
  );
};
